// For the enums, this can be used to get all the values
export type ValueOf<T> = T[keyof T];

export enum ACCELERATE_GIG_ACTION {
  TO_IN_PROGRESS = 'to_in_progress',
  TO_CANCELLATION_TERM = 'to_cancellation_term',
  TO_PAYOUT = 'to_payout',
}

export enum Region {
  NETHERLANDS = 'nl',
  BELGIUM = 'be',
  UNITED_KINGDOM = 'gb',
  FRANCE = 'fr',
}

export enum MantineDatesProviderLocale {
  NETHERLANDS = 'nl',
  BELGIUM = 'nl-BE',
  ENGLISH = 'en',
}

export enum JOBSTATUS {
  OPEN = 'open',
  READY_FOR_EXECUTION = 'ready_for_execution',
  IN_PROGRESS = 'in_progress',
  PAYOUT = 'payout',
  ARCHIVED = 'archived',
  TO_APPROVE = 'to_approve',
}

export enum SKILLSTATUS {
  ACTIVE = 'ACTIVE',
  DRAFT = 'DRAFT',
  MERGED = 'MERGED',
  ARCHIVED = 'ARCHIVED',
}

export enum SUPPORTED_SUCCESS_STATUS_CODES {
  UPDATED = 205,
  SUCCESS = 200,
}

/** Error codes for which we have error messages */
export enum SUPPORTED_ERROR_STATUS_CODES {
  CONFLICT = 409,
  NOT_FOUND = 404,
}

export enum SORT_DIRECTION {
  ASC = 'asc',
  DESC = 'desc',
}

export enum ERRORS_IDENTIFIERS {
  ENTITY_FOUND = 'validation.entity_found',
}

export enum FREELANCER_BAN_REASON {
  REASON_NO_SHOW_FOR_JOB = 'REASON_NO_SHOW_FOR_JOB',
  SYSTEM_POLICY_NO_SHOW_2 = 'SYSTEM_POLICY_NO_SHOW_2',
  SYSTEM_POLICY_NO_SHOW_3 = 'SYSTEM_POLICY_NO_SHOW_3',
  SYSTEM_POLICY_NO_SHOW_4 = 'SYSTEM_POLICY_NO_SHOW_4',
  REASON_FIVE_TIME_NO_SHOW = 'REASON_FIVE_TIME_NO_SHOW',
  REASON_MANUAL_VIA_ADMIN = 'REASON_MANUAL_VIA_ADMIN',
  REASON_REMOVED = 'REASON_REMOVED',
  REASON_INVALID_COC_NUMBER = 'REASON_INVALID_COC_NUMBER',
  REASON_REVERTED = 'REASON_REVERTED',
}

export enum FREELANCER_BAN_DURATION {
  P14D = 'P14D',
  P1M = 'P1M',
  P3M = 'P3M',
}

export enum QUEUE_STATUS {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum ROLES {
  ROLE_CALL_TEAM = 'ROLE_CALL_TEAM',
  CUSTOMER_SUCCESS = 'CUSTOMER_SUCCESS',
  BUSINESS_DEVELOPMENT = 'BUSINESS_DEVELOPMENT',
  SALES_DEVELOPMENT = 'SALES_DEVELOPMENT',
  FREELANCE_SUCCESS = 'FREELANCE_SUCCESS',
  ADMIN_COUNTRY = 'ADMIN_COUNTRY',
  ADMIN_GLOBAL = 'ADMIN_GLOBAL',
  FREELANCE_SUPPORT = 'FREELANCE_SUPPORT',
  FINANCE = 'FINANCE',
  FINANCE_ADMIN = 'FINANCE_ADMIN',
}

export enum REQUEST_VERIFICATION_STATE {
  REQUEST_VERIFICATION = 'request_verification',
  UNVERIFY_AND_REQUEST_VERIFICATION = 'unverify_and_request_verification',
}

export enum DATE_FORMAT {
  DEFAULT_DATE_TIME_FORMAT = 'dd/MM/yyyy HH:mm zzz',
  DEFAULT_DATE_FORMAT = 'dd/MM/yyyy',
}

export const INVOICE_STATUS = {
  QUEUED: 1,
  READY: 2,
  OPEN: 3,
  BILLED: 4,
  PAID: 5,
  COMPLETED: 6,
} as const;

export type INVOICE_STATUS = typeof INVOICE_STATUS[keyof typeof INVOICE_STATUS];
